module.exports = __webpack_public_path__ + "arrow_l.d3246e19.png";